<template>
  <div />
</template>

<script>
import Mixin from './mixin/Mixin'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import Constant from '@/const'
import Store from '@/store/index.js'
import CryptoJS from 'crypto-js'

export default {
  name: 'ProxyLogin',

  mixins: [Mixin],

  methods: {
    proxyLogin() {
      this.spinerOn()
      const encrypted = this.$route.query.d
      if (!encrypted) return this.gotoLogin()

      let dencrypted = null
      try {
        dencrypted = CryptoJS.AES.decrypt(
          atob(encrypted.replace('%3D', '')),
          process.env.CRYPTO_KEY
        ).toString(CryptoJS.enc.Utf8)

        this.$store
          .dispatch('auth/proxy', JSON.parse(dencrypted))
          .then((res) => {
            this.$router.push({
              name: 'Home',
            })
          })
          .catch(() => this.gotoLogin())
      } catch (e) {
        this.gotoLogin()
      } finally {
        this.spinerOff()
      }
    },

    gotoLogin() {
      window.close()
      this.$router.push({
        name: 'Login',
      })
    },
  },

  mounted() {
    this.proxyLogin()
  },
}
</script>

<style lang="sass" scoped>
@import '../assets/css/logico2'
section#note
  .md-card
    width: 50%
    margin: 5px auto
    background: pink
    color: red
    font-weight: bold
    @include sp
      font-size: 14px
      margin: 10px auto
      width: 100%

section#login-form
  .md-card-header
    background: $baseBlueColor
    color: white
  .form
    width: 50%
    margin: 40px auto
    @include sp
      margin: 10px auto
      width: 100%
  .md-button
    @extend.base-btn
    @extend.f-size-16
    background: $baseGreenColor
    border-radius: 5px
#apply-modal
  .btn-wrapper
    text-align: center
    .md-button
      width: 90%
      font-size: 18px
  @include sp
    .btn-wrapper
      .md-button
        font-size: 16px
.err-message
  p
    text-align: left
</style>

<style lang="sass">
@import '../assets/css/logico2'
#new-apply-btn
  @extend.base-btn
  @extend.f-size-16
  background: orange !important
  border-radius: 5px
  .md-button-content
    color: black
</style>



// WEBPACK FOOTER //
// src/components/ProxyLogin.vue